module.exports = __webpack_public_path__ + "static/img/academica-2666259.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/academica.jpg
// module id = rK60
// module chunks = 1